import { useState } from "react";
import Button from "../../components/core/button.core";
import { Outlet } from "react-router-dom";

export default function AuthLayoutPartial() {
	const [next, setNext] = useState<boolean>(false);

	return (
		<div className="relative flex sm:flex-row flex-col sm:justify-center bg-white w-full min-h-screen text-soloprimary">
			{/* Mobile View Sliding Panel */}
			<div
				className={`z-30 absolute sm:hidden flex flex-col justify-between gap-7 bg-white px-5 pt-10 w-full h-full transition-transform duration-300 ease-in-out ${
					next ? "-translate-x-full" : "translate-x-0"
				}`}
			>
				<div className="flex flex-col w-full">
					<h1 className="font-cabinetgrotesk font-normal text-4xl leading-10 tracking-tighter">
						The premium creator collaboration platform.
					</h1>
					<p className="opacity-50 pt-3 font-figtree font-semibold text-sm">
						We assure high-quality engagement with our invite-only creator
						network, strict content vetting and measurable ROI.
					</p>
					<p className="flex items-center gap-3 pt-3 font-figtree font-semibold text-sm tracking-tight">
						Trusted by
						<img
							src="/static/clients.png"
							className="w-28 aspect-[468/116]"
							alt=""
						/>
					</p>
				</div>
				<div className="flex-grow bg-gray-100 rounded w-full" />
				<div className="pb-4 w-full">
					<Button
						onClick={() => setNext(true)}
						className="w-full font-semibold font-sm"
					>
						Continue
					</Button>
				</div>
			</div>

			{/* Main Layout */}
			<div className="items-center md:gap-10 grid sm:grid-cols-2 w-full md:w-fit">
				{/* Image - only on larger screens */}
				<div className="sm:flex justify-center items-center hidden rounded-3xl w-full max-w-lg">
					<img
						className="w-full h-auto object-contain"
						draggable={false}
						src="/static/signup.png"
						alt=""
					/>
				</div>

				{/* Form / Outlet */}
				<Outlet />
			</div>
		</div>
	);
}
